export const GOTO_STEP = 'GOTO_STEP@form';
export const GOTO_PREV_STEP = 'GOTO_PREV_STEP@form';
export const GOTO_NEXT_STEP = 'GOTO_NEXT_STEP@form';
export const SET_CONVENTION = 'SET_CONVENTION@form';
export const SET_PRIVACY_INFO = 'SET_PRIVACY_INFO@form';
export const SET_PRODUCTS = 'SET_PRODUCTS@form';
